export type ConnectionRendererPropsType = {
	children?: any;
	watch?: 'online' | 'offline';
	online?: boolean;
};

const ConnectionRenderer = ({ watch = 'online', online, children }: ConnectionRendererPropsType) => {
	switch (watch) {
		case 'online':
			if (online) {
				return children;
			}
			break;
		case 'offline':
			if (!online) {
				return children;
			}
			break;
		default:
			break;
	}

	return null;
};

ConnectionRenderer.displayName = 'ConnectionRenderer';

export default ConnectionRenderer;
